export default __webpack_public_path__ + "static/media/4left.3e057b63.png";